// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".square[data-v-64b1b36a] {\n  width: 50%;\n  height: 0;\n  padding-top: 100%;\n  background-color: #e0e9f3;\n  border-radius: 50%;\n  position: relative;\n}\n.square .the-content[data-v-64b1b36a] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #1d4c72;\n}\n.name-file[data-v-64b1b36a] {\n  word-break: break-all;\n}\n.sticky-column[data-v-64b1b36a] {\n  position: sticky;\n  top: 10px;\n  max-height: 95vh;\n}", ""]);
// Exports
module.exports = exports;
